import { Route, Redirect } from "react-router-dom";
import React from "react";
import { store } from '../../../redux/store';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const state = store.getState();
  console.log(state);
  return (
    <Route
      {...rest}
      render={(props) => {
        if (state && state.userData && state.userData.token) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: rest.redirectRoute,
                extras: { ...rest.location },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
